export default "__VITE_ASSET__BkurTv5M__"